import styled, { css } from 'styled-components';

const StyledIcon = styled.span`
  display: inline-block;
  padding: 10px 0 9px;
  vertical-align: middle;

  /**
   * TODO: Pārskatīt šo
   */
  ${({hasLabel}) => hasLabel && css`
    transform: translateY(-1px);
  `}

  * + & {
    margin-left: 0.35em;
  }

  & + * {
    margin-right: 0.35em;
  }
`;

export default StyledIcon;



// WEBPACK FOOTER //
// ./src/elements/Button/styled/StyledIcon.js